import { IconButton, SxProps, Theme } from '@mui/material';
import { ContentCopy } from '@mui/icons-material';
import { useToastService } from '@@common';

interface CopyToClipboardButtonProps {
	value?: string;
	size?: 'small' | 'medium' | 'large';
	title?: string;
	edge?: 'start' | 'end' | false;
	iconSize?: number;
	sx?: SxProps<Theme>;
	onClick?: () => string;
	disabled?: boolean;
}

export default function CopyToClipboardButton({
	value,
	size = 'small',
	title = 'Copy value to clipboard',
	edge = 'end',
	iconSize = 18,
	sx,
	onClick,
	disabled = false,
}: CopyToClipboardButtonProps) {
	const toastService = useToastService();

	const handleCopyToClipboard = () => {
		const textToCopy = onClick ? onClick() : value || '';
		navigator.clipboard.writeText(textToCopy);
		toastService.success('Copied to clipboard');
	};

	return (
		<IconButton size={size} onClick={handleCopyToClipboard} title={title} edge={edge} sx={sx} disabled={disabled}>
			<ContentCopy sx={{ fontSize: iconSize }} />
		</IconButton>
	);
}
